module.exports = __webpack_public_path__ + "img/background.593a909d.png";